var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"report",staticStyle:{"border":"0"},attrs:{"allowfullscreen":"","frameborder":"0","src":_vm.config.embedUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }